module.exports = {
  maps: {
    defaultPin: {
      url: '/assets/images/map-pin.svg',
      width: 36,
      height: 54
    },
    api: {
      KEY: 'AIzaSyDyxLx1XP_ePZz-A535dAY2hYbg9kOQEik',
      SENSOR: false,
      LIBRARIES: ['places']
    },
    center: {
      lat: -24.939602,
      lng: 31.578375
    },
    defaults: {
      zoom: 3,
      maxZoom: 12,
      minZoom: 1,
      disableDefaultUI: false,
      mapTypeControl: false,
      streetViewControl: false,
      scrollwheel: true,
      zoomControl: true
    },
    cluster: {
      gridSize: 50,
      maxZoom: 10
    }
  }
};



/*****************
 ** WEBPACK FOOTER
 ** ./source/scripts/config.js
 ** module id = 157
 ** module chunks = 0 1
 **/